/**
 * Portal props for a modal that may render either inside Moo Studio or outside it.
 *
 * `#moo-studio-portal` is a div rendered by `MooStudioLayout`. Components that
 * live only in Studio can target it directly, but several now render in both
 * places — the composer's settings modal reuses Studio sections verbatim.
 *
 * A Mantine portal pointed at a selector that matches nothing never mounts, and
 * it fails silently: the dialog simply does not appear, which reads as a dead
 * button rather than an error. Returning `{}` when the target is absent lets
 * Mantine fall back to its default body portal.
 */
export function studioPortalProps(): {
  portalProps?: { target: HTMLElement };
} {
  if (typeof document === 'undefined') return {};
  const target = document.getElementById('moo-studio-portal');
  return target ? { portalProps: { target } } : {};
}
